import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { LanguageCreateService } from '../../services';

export const fetchLanguageCreate = createAsyncThunk(
    'languageCreate/fetchLanguageCreate',
    async ({ file, lang, code, zipCode }) => {
        const response = await LanguageCreateService(file, lang, code, zipCode)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const languageCreateSlice = createSlice({
    name: 'languageCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLanguageCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLanguageCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchLanguageCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default languageCreateSlice.reducer;
